import { render, staticRenderFns } from "./HRMSProviderComponent.vue?vue&type=template&id=156f43d5&"
import script from "./HRMSProviderComponent.vue?vue&type=script&lang=ts&"
export * from "./HRMSProviderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports